<div class="container-fluid">
  <div class="row text-left">
    <div class="col-sm-12">
      <div class="d-flex justify-content-between">
        <h2 class="font-size-4 font-size-md-7 text-bold-500 mb-3 mb-lg-4">
          {{
            activeRoute === "reports"
              ? "Financeiro"
              : activeRoute === "subscriptions"
              ? "Assinaturas"
              : activeRoute === "account"
              ? "Conta"
              : "Título Padrão"
          }}
        </h2>
      </div>
      <div class="row">
        <div class="col-12 mt-2 mb-2">
          <a
            class="btn-link text-decoration-none font-size-4 font-size-md-5"
            routerLink="reports"
            title="Relatorios"
            routerLinkActive="selected"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <i class="ft-bar-chart-line-"></i>
            Relatórios
          </a>
          <a
            class="btn-link text-decoration-none font-size-4 font-size-md-5"
            routerLink="subscriptions"
            title="Assinaturas"
            routerLinkActive="selected"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <svg
              width="18"
              height="16"
              viewBox="0 0 18 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7606 9.0188C16.43 10.7758 15.4934 12.3197 14.1777 13.4251C12.8537 14.5374 11.1493 15.207 9.28992 15.207C7.5426 15.207 5.93087 14.6163 4.64563 13.623C3.33134 12.6089 2.36015 11.1742 1.92989 9.51961L2.87895 9.27336C3.25248 10.7135 4.09916 11.9628 5.24329 12.8468C6.36112 13.7101 7.76396 14.2234 9.28853 14.2234C10.9113 14.2234 12.3972 13.641 13.5468 12.6753C14.6467 11.7511 15.4422 10.4742 15.7576 9.01742H14.7435L16.264 7.16496L17.7844 9.01742H16.7606V9.0188ZM9.26501 9.55558V7.81934C8.65352 7.66439 8.20667 7.43058 7.92306 7.11792C7.63806 6.80387 7.49418 6.42342 7.49418 5.97518C7.49418 5.5214 7.65605 5.13957 7.97839 4.83244C8.30074 4.52393 8.72961 4.34684 9.26501 4.2998V3.89168H9.94845V4.2998C10.4493 4.35238 10.8463 4.50317 11.1438 4.75081C11.4384 4.99845 11.628 5.33048 11.7096 5.74552L10.5157 5.8811C10.4423 5.55461 10.2528 5.33325 9.94845 5.21704V6.83708C10.7038 7.01554 11.2185 7.24935 11.491 7.53434C11.7649 7.82072 11.9019 8.18734 11.9019 8.63558C11.9019 9.13639 11.7303 9.55697 11.3859 9.90007C11.0414 10.2432 10.5627 10.4562 9.94845 10.5406V11.3153H9.26501V10.5503C8.72546 10.4922 8.28829 10.3165 7.94934 10.0204C7.61039 9.72437 7.39596 9.30518 7.30188 8.76424L8.52348 8.63696C8.57328 8.85832 8.66736 9.04785 8.80571 9.20833C8.94405 9.36882 9.09623 9.48364 9.26501 9.55558ZM9.26501 5.20182C9.08101 5.25993 8.93575 5.35539 8.82922 5.4882C8.72131 5.62101 8.66874 5.76766 8.66874 5.92814C8.66874 6.07479 8.71716 6.21037 8.81539 6.33626C8.91362 6.46077 9.06441 6.56315 9.2664 6.63924V5.20182H9.26501ZM9.94845 9.62476C10.1836 9.5791 10.3773 9.47949 10.524 9.32731C10.6734 9.17375 10.7467 8.9939 10.7467 8.78499C10.7467 8.60099 10.6844 8.44051 10.5586 8.3077C10.4354 8.1735 10.2321 8.07113 9.94706 7.99919V9.62476H9.94845ZM1.81783 6.18962C2.14571 4.44784 3.06848 2.91634 4.36479 1.81234C5.69291 0.682048 7.41256 0 9.28853 0C10.939 0 12.4663 0.525716 13.7129 1.41943C14.9926 2.33667 15.9748 3.64128 16.4908 5.16309L16.026 5.3208L15.5612 5.47852C15.5487 5.43978 15.5349 5.40104 15.521 5.36369C15.0631 4.08952 14.2233 2.99658 13.1415 2.22046C12.0568 1.44295 10.7273 0.985026 9.28992 0.985026C7.6519 0.985026 6.15361 1.57715 4.9998 2.55941C3.91516 3.48218 3.1335 4.74805 2.81946 6.18962H3.828L2.30619 8.04207L0.785767 6.18962H1.81783Z"
                fill="#9E9E9E"
              />
            </svg>

            Assinaturas
          </a>
          <a
            class="btn-link text-decoration-none font-size-4 font-size-md-5"
            routerLink="account"
            title="Conta"
            routerLinkActive="selected"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <i class="fa fa-address-card"></i>
            Conta
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
